import axios from "axios";
import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader, getUploadHeader } from "../_helpers/header.helper";


const API_NAME = "formFieldKey";

export const formFieldKeyService = {
    get,
    getAll,
    post,
    put,
    disable,
    dropdown,
    dropdownSections,
};

function get(id: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/get/?id=${id}`, requestOptions).then(handleResponse);
}

function getAll(formTemplateSectionId: number) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getAll/?formTemplateSectionId=${formTemplateSectionId}`, requestOptions).then(handleResponse);
}

function post(model?: FormData) {
    const config = {
        headers: getUploadHeader()
    }

    return axios.post(`${API_URL}/${API_NAME}/`, model, config);
}

function put(model?: FormData) {
    const config = {
        headers: getUploadHeader()
    }

    return axios.put(`${API_URL}/${API_NAME}/`, model, config);
}


function disable(id: number) {
    const requestOptions = { method: 'DELETE', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/${id}`, requestOptions).then(handleResponse);
}

function dropdown(formTemplateSectionId: number) {
    const requestOptions = { method: 'Get', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/dropdown/?formTemplateSectionId=${formTemplateSectionId}`, requestOptions).then(handleResponse);
}

function dropdownSections(formTemplateSectionId: number) {
    const requestOptions = { method: 'Get', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/dropdownSections/?formTemplateSectionId=${formTemplateSectionId}`, requestOptions).then(handleResponse);
}